import React, { useState, useEffect, useMemo } from "react";
import { Formik, Form, FormikHelpers } from "formik";
import * as Yup from "yup";

//MUI
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";

import FormikControl from "../../components/formik/FormikControl";
import Loader from "../../components/loader/Loader";

import FinanceService from "../../services/FinanceService";
import { Mode } from "./FinancePage";
// import { statusOptions } from "../../utility/utils";
import { fetchFinances } from "../../redux/actions/FinanceActions";
import { useAppDispatch, useAppSelector } from "../../redux/hooks/redux-hooks";
import { FinanceModel } from "../../models/FinanceModel";

const validationSchema = Yup.object({
  name: Yup.string().required("Required"),
  description: Yup.string().required("Required"),
  // status: Yup.string().required("Required"),
});

type FormProps = Yup.InferType<typeof validationSchema>;

type Props = {
  mode: Mode;
  handleModalClose: () => void;
  data?: FinanceModel;
};

const FinanceForm = ({ mode, handleModalClose, data }: Props) => {
  const initialValues = useMemo(
    () => ({
      name: "",
      description: "",
      // status: "",
    }),
    []
  );

  const [formState, setFormState] = useState<FormProps>(initialValues);
  const dispatch = useAppDispatch();
  const displayToast = useAppSelector((state) => state.toast.displayToast);

  useEffect(() => {
    if (mode === "edit" && data) {
      setFormState(() => ({
        name: data.name,
        description: data.description,
        // status: data.isActive ? "active" : "inactive",
      }));
    }
  }, [mode, data]);

  const submitHandler = async (
    values: FormProps,
    actions: FormikHelpers<FormProps>
  ) => {
    try {
      let formData: FinanceModel = {
        fundingSourceId: 0,
        name: "",
        description: "",
        isActive: true,
        createdDate: new Date(),
        modifiedDate: new Date(),
      };
      if (mode === "add") {
        formData.name = values.name;
        formData.description = values.description;
        // formData.isActive = values.status === "active" ? true : false;
      } else if (data) {
        formData = {
          ...data,
          name: values.name,
          description: values.description,
          // isActive: values.status === "active" ? true : false,
          modifiedDate: new Date(),
        };
      }
      await FinanceService.createFinance(formData, data?.fundingSourceId);
      actions.setSubmitting(false);
      handleModalClose();
      dispatch(fetchFinances());
      displayToast(
        `Funding source ${mode === "add" ? "created" : "updated"} successfully`,
        "success"
      );
    } catch (error) {
      actions.setSubmitting(false);
    }
  };
  return (
    <Formik
      initialValues={formState}
      validationSchema={validationSchema}
      onSubmit={submitHandler}
      enableReinitialize={true}
    >
      {(formik) => (
        <>
          <Form>
            <Stack gap={2}>
              <FormikControl
                control="input"
                type="text"
                name="name"
                size="small"
                label="Funding Source"
                placeholder="Enter Funding Source"
              />
              <FormikControl
                control="input"
                multiline
                maxRows={2}
                name="description"
                size="small"
                label="Description"
                placeholder="Enter Description"
              />
              {/* <FormikControl
                control="autocomplete"
                options={statusOptions}
                name="status"
                size="small"
                label="Status"
                placeholder="Select Status"
              /> */}
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={formik.isSubmitting}
              >
                Submit
              </Button>
            </Stack>
          </Form>
          {formik.isSubmitting && <Loader />}
        </>
      )}
    </Formik>
  );
};

export default FinanceForm;
